import React from 'react';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import SelectColumnFilter from '../../../../../components/table/SelectColumnFilter';
import {
  EVENT_STATUS,
  EVENT_STATUS_SELECT_LIST,
  EVENT_STATUS_TEXT,
} from '../../../../../constants/service/app/eventConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  선택된 기획전 아이템 리스트와 기획전 리스트의 공통 컬럼
 */
export const columns = (data) => {
  const { filterOption, onFilter } = data;
  return [
    {
      accessor: 'url',
      Header: '이미지',
      width: 100,
      fixed: 'left',
      Cell: (row) => <TableColumnImg url={row.value} openImgViewModal={data.openImgViewModal} />,
    },
    {
      accessor: 'status',
      Header: '상태',
      filterable: !!filterOption,
      width: 90,
      fixed: 'left',
      Cell: (row) => EVENT_STATUS_TEXT[row.value] || '_',
      Filter: ({ column }) => (
        <SelectColumnFilter
          list={EVENT_STATUS_SELECT_LIST}
          column={column}
          onChange={({ value, id }) => {
            onFilter({ [id]: value ? Number(value) : null });
          }}
        />
      ),
    },
    {
      accessor: 'id',
      Header: '기획전 ID',
      filterable: !!filterOption,
      width: 90,
      fixed: 'left',
      Filter: () => <TableFilterInput option={filterOption.eventId} onFilter={(eventId) => onFilter({ eventId })} />,
    },
    {
      accessor: 'mainTitle',
      Header: '제목',
      filterable: !!filterOption,
      width: 250,
      fixed: 'left',
      Filter: () => (
        <TableFilterInput option={filterOption.mainTitle} onFilter={(mainTitle) => onFilter({ mainTitle })} />
      ),
    },
    {
      accessor: 'eventPeriod',
      Header: '기간',
      width: 160,
      Cell: (row) =>
        row.original.status === EVENT_STATUS.unlimited
          ? EVENT_STATUS_TEXT[row.original.status]
          : `${setDateFormat(row.original.startDate, DATE_FORMAT.FULL_DASH_FORMAT)} -\n ${setDateFormat(
              row.original.endDate,
              DATE_FORMAT.FULL_DASH_FORMAT,
            )} `,
    },
    {
      accessor: 'contents',
      Header: '기획전 본문',
      filterable: !!filterOption,
      width: 300,
      Filter: () => <TableFilterInput option={filterOption.contents} onFilter={(contents) => onFilter({ contents })} />,
    },
    {
      accessor: 'memo',
      Header: '메모',
      filterable: !!filterOption,
      width: 300,
      Filter: () => <TableFilterInput option={filterOption.memo} onFilter={(memo) => onFilter({ memo })} />,
    },
  ];
};
